var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6247 0.219168C14.056 0.564178 14.1259 1.19347 13.7809 1.62473L5.78087 11.6247C5.60318 11.8468 5.33931 11.9828 5.0553 11.9985C4.77129 12.0142 4.49403 11.9083 4.29289 11.7071L0.292893 7.70714C-0.0976311 7.31662 -0.0976311 6.68345 0.292893 6.29293C0.683417 5.90241 1.31658 5.90241 1.70711 6.29293L4.91708 9.5029L12.2191 0.375342C12.5641 -0.0559202 13.1934 -0.125842 13.6247 0.219168Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/check-mark.babbc18c2664d4283cbd47f66b4f46ba.svg";
export { ForwardRef as ReactComponent };